import './UserProfileCellRenderer.scss';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { Button, Modal, ModalBody } from 'react-bootstrap';
import { connect } from 'react-redux';
import { toast } from '../../../../components/utils';
import { gridsSetEditDeleteCRAction, store } from '../../../../redux';

function UserProfileCellRenderer({
  data,
  lockOutExpireDate,
  phoneNumber,
  confirmedEmail,
  api,
  onClickEdit,
  onClickDelete,
  onClickCancelEdit,
  editDeleteCR,
  setEditDeleteCR,
}) {
  const userName = data.userName?.toLowerCase() || data.email?.toLowerCase();
  const id = data.userId;
  const currentUserRole = store.getState()?.auth?.user?.role;
  const userRole = data.userRole;
  const ssoAccount = data.ssoAccount;

  const [modal, setModal] = useState(false);

  const onClickUserProfile = () => {
    setModal(!modal);
  };

  const resetContext = () => {
    const ctx = { id: null, isEditing: false };
    setEditDeleteCR(ctx);
  };

  const _onClickEdit = () => {
    resetContext();
    const ctx = { id, isEditing: true };
    setEditDeleteCR(ctx);
    onClickEdit();
    setModal(!modal);
  };

  const _onClickCancelEdit = () => {
    api.stopEditing(true);
    onClickCancelEdit();
  };

  const handleContactUser = () => {
    const mailtoLink = `mailto:${userName}`;

    // Open email client
    window.location.href = mailtoLink;

    // Copy email to clipboard
    navigator.clipboard
      .writeText(userName)
      .then(() => {
        toast.success('Email copied to clipboard!');
      })
      .catch((err) => {
        console.error('Clipboard error:', err);
        toast.error('Failed to copy email.');
      });
  };

  // Disable edit and delete if:
  // 1. The user is an SSO account
  // 2. The logged-in user is NOT a Super Admin but is trying to edit/delete a Super Admin
  const disableEditDelete =
    ssoAccount ||
    (userRole === 'SuperAdmin' && currentUserRole !== 'SuperAdmin') ||
    (userRole === 'SystemAdmin' &&
      currentUserRole !== 'SuperAdmin' &&
      currentUserRole !== 'SystemAdmin');

  return (
    <>
      <Modal
        className="acc-mgm-user-profile-container"
        centered
        show={modal}
        onHide={() => setModal(false)}
      >
        <ModalBody>
          <div className="d-flex justify-content-end">
            <Button variant="light" onClick={() => setModal(false)}>
              <i className="fa fa-times" />
            </Button>
          </div>
          <div className="user-profile-pic">
            <span className="user-initials fs-6x">{userName?.charAt(0).toUpperCase()}</span>
          </div>

          <div className="user-profile-info text-center">
            <div className="user-role-text">{ssoAccount ? 'SSO' : userRole}</div>
            <div>Email: {userName}</div>
            {data.phoneNumber && <div>Phone: {phoneNumber}</div>}
            {data.lockoutEnd && <div>Lock Out Expiration: {lockOutExpireDate}</div>}
            <div>Email Confirmed: {confirmedEmail}</div>
          </div>

          <div className="mt-5 mb-3 d-flex justify-content-evenly button-container">
            {confirmedEmail === 'YES' && (
              <Button variant="primary" onClick={handleContactUser}>
                Contact User
              </Button>
            )}
            <Button variant="primary" onClick={_onClickEdit} disabled={disableEditDelete}>
              Edit User Role
            </Button>
            <Button
              variant="danger"
              disabled={disableEditDelete}
              onClick={
                editDeleteCR?.isEditing
                  ? () => {
                      _onClickCancelEdit(), onClickDelete();
                    }
                  : () => {
                      onClickDelete();
                    }
              }
            >
              Delete User
            </Button>
          </div>
        </ModalBody>
      </Modal>

      <button className="w-100 d-block text-dark user-text-btn" onClick={onClickUserProfile}>
        {userName}
      </button>
    </>
  );
}

UserProfileCellRenderer.propTypes = {
  onClickEdit: PropTypes.func.isRequired,
  onClickDelete: PropTypes.func.isRequired,
  onClickCancelEdit: PropTypes.func.isRequired,
  onClickConfirmEdit: PropTypes.func.isRequired,
  api: PropTypes.object.isRequired,
  editDeleteCR: PropTypes.object.isRequired,
  setEditDeleteCR: PropTypes.func.isRequired,
};

const mapStateToProps = ({ grids }) => ({
  editDeleteCR: grids.editDeleteCR,
});

const mapDispatchToProps = (dispatch) => ({
  setEditDeleteCR: (editDeleteCR) => dispatch(gridsSetEditDeleteCRAction({ editDeleteCR })),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserProfileCellRenderer);
